<template>
  <div class="bgc" v-if="test">
    <div>
      <div class="bgc-kong">
        <div class="examTop">
          <div class="goBack" @click="goback">
            <img src="../../assets/img/study/exam/icon_fanhui.png" alt/>
            返回
          </div>
          <div class="examName" style="text-align: center">{{exam.examName}}</div>
        </div>
      </div>
      <div class="exam">
        <div class="examCont">
          <div class="examTop1"></div>

          <div class="examType">
            <!-- 试题列表 -->
            <div
                class="examList"
                :class="`examList${item.id}`"
                :ref="`examList${item.id}`"
                v-for="(item, i) in examList"
                :key="i"
            >
              <div class="topic" flex>
                <div v-if="item.flag == 0" class="status">单选题</div>
                <div v-if="item.flag == 4" class="status status1">多选题</div>
                <div v-if="item.flag == 3" class="status status2">判断题</div>
                <div v-if="item.flag == 1" class="status">填空题</div>
                <div v-if="item.flag == 2" class="status status1">简答题</div>

                <div v-if="item.flag == 5" class="status status5">英汉翻译</div>
                <div v-if="item.flag == 6" class="status status6">阅读理解</div>
                <div v-if="item.flag == 7" class="status status7">名词解释</div>
                <div v-if="item.flag == 8" class="status status8">计算题</div>
                <span class="index">{{i+1}}.</span>
                <!--<div v-if="item.type == 7" class="status status2">作文</div>-->
                <div class="text" v-html="item.content"></div>
              </div>
              <div class="option">
                <!-- 单选题目 -->

                <el-radio-group disabled v-model="item.userAnswer==null ? null : item.userAnswer-0" v-if="item.flag == 0">
                  <div class="choose" v-for="(key, val) in item.options" :key="val" >
                    <el-radio :label="val" >
                      <span v-html="key"></span>
                    </el-radio>
                  </div>

                </el-radio-group>
                <!-- 多选题目 -->
                <el-checkbox-group
                        disabled v-model="item.userAnswer" v-if="item.flag == 4"
                >

                  <el-checkbox
                      class="choose"
                      :label="val"
                      v-for="(key, val) in item.options"
                      :key="val"
                  >
                    <span v-html="key"></span>
                  </el-checkbox>
                </el-checkbox-group>
                <!-- 判断题 -->
                <el-radio-group
                        disabled v-model="item.userAnswer==null ? null : item.userAnswer-0"
                    v-if="item.flag == 3"
                >
                  <div class="choose" v-for="(key, val) in item.selectOption" :key="val">
                    <el-radio :label="val">
                      <span v-html="key"></span>
                    </el-radio>
                  </div>
                </el-radio-group>
                <!-- 填空题 -->
                <el-input
                    class="response"
                    type="textarea"
                    readonly
                    v-model="item.userAnswer"
                    v-if="item.flag == 2 || item.flag == 1 || item.flag == 5 || item.flag == 6 || item.flag == 7 || item.flag == 8"
                    :autosize="{ minRows: 2}"
                    placeholder="请输入内容"
                ></el-input>
                <div class="contrast">
<!--                  <div class="result" v-if="item.flag == 1 " style="font-size: 16px;">-->
<!--                    您的答案是:-->
<!--                    <span class="big">{{item.status==0 || item.status==null?'空': item.userAnswer}}</span>得-->
<!--                    <span>1</span>-->
<!--                    分-->
<!--                  </div>-->
                  <div class="correct" v-if="item.status!=1" style="font-size: 16px;">
                    正确答案:
                    <span>{{item.answer}}</span>
                  </div>
                </div>

<!--                <div class="contrast">-->
<!--                  <div class="result" v-if="item.flag == 2" style="font-size: 16px;">-->
<!--                    您的答案是:-->
<!--                    <span class="big">{{item.status==0 ?'空': item.userAnswer}}</span>得-->
<!--                    <span>1</span>分-->
<!--                  </div>-->
<!--                </div>-->
                <!--              <div class="correct" v-if="item.status!=1">-->
                <!--                <span>正确答案:</span>-->
                <!--                <span>{{item.answer}}</span>-->
                <!--              </div>-->
                <div
                        class="resultBtn_box"
                        :class="{ resultBtn1: item.status != 1 }"
                        v-if="item.flag == 0 || item.flag == 4 || item.flag == 3 || item.flag ==1  || item.flag == 2 || item.flag == 5 || item.flag == 6 || item.flag == 7 || item.flag == 8"
                        style="font-size: 16px;"
                >{{ item.status== 1 ? "正确" : "答错了" }}</div>
                <div class="analysis" v-if="item.flag == 0 || item.flag == 4 || item.flag == 3 || item.flag ==1  || item.flag == 2 || item.flag == 5 || item.flag == 6 || item.flag == 7 || item.flag == 8"
                     style="font-size: 16px;">
                  <span>解析：</span>
                  {{item.analysis?item.analysis:'无'}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧答题卡 -->
        <div class="answer">
          <div class="answerTitile">答题卡</div>
          <div class="answerTop">
            <div class="whether">
              <div class="whetherItem">
                <div></div>
                <div>正确</div>
              </div>
              <div class="whetherItem">
                <div></div>
                <div>未答</div>
              </div>
              <div class="whetherItem">
                <div></div>
                <div>答错</div>
              </div>
            </div>
            <div class="num">
              您共答错
              <span>{{num}}道题</span> 点击序号查看错题
            </div>
          </div>

<!--                  <div class="answerCard">-->
<!--                    <div class="typeItem" v-for="(item, index) in examList" :key="index">-->

<!--          &lt;!&ndash;    <div class="type" v-if="item.type==0">单选题</div>-->
<!--              <div class="type" v-if="item.type==4">多选题</div>-->
<!--              <div class="type" v-if="item.type==3">判断题</div>-->
<!--              <div v-if="item.flag == 1" class="status">填空题</div>-->
<!--              <div v-if="item.flag == 2" class="status status1">简答题</div>&ndash;&gt;-->


<!--                      <div class="answerList flex">-->
<!--                        <div v-if="item.flag==0" class="noAnswer" @click="goDingyue(item.id)">{{index+1}}</div>-->
<!--                        <div v-if="item.flag==1" @click="goDingyue(item.id)">{{index+1}}</div>-->
<!--                        <div v-if="item.flag==2" class="errorAnswer" @click="goDingyue(item.id)">{{index+1}}</div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->

          <div class="answerCard">
            <div class="answerList flex">
              <div
                  v-for="(item, index) in examList"
                  :class="item.status == 0 || item.status == null? 'noAnswer':item.status==2 ?'errorAnswer':''"
                  :key="index"
                  @click="goDingyue(item.id)"
              >{{index+1}}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { analysis } from "../../assets/js/api.js";
let timer = null;
let singleAnswer = {};
export default {
  name: "analysis",
  data() {
    return {
      test: false,
      // flag: false,
      dingYue: "",
      // 后台数据
      id: 0,
      examId:0,
      exam: "",
      // 试题列表
      examList: [],
      // 答题卡数据
      cardList: [],
      num: 0,
      // 答案
      answer: [],
    };
  },
  mounted() {
    if (!this.$route.query.examDoId) {
      this.$router.push("/index");
      return
    }
    console.log(this.$route.query.examDoId);
    this.id = this.$route.query.examDoId;
    this.examId = this.$route.query.examId;
    window.scroll(0, 0);
    this.analysiData();
  },
  beforeDestroy() {
    //页面关闭时清除定时器
    clearInterval(timer);
  },
  computed: {},
  watch: {},
  methods: {
    // 试卷
    analysiData() {
      analysis(this.examId, this.id).then((res) => {
        this.test = true;
        console.log(res);
        if (res.code == 200) {
          this.exam = res.data;
          this.num = res.data.num;

          console.log("res.data1===="+JSON.stringify(res.data))
          res.data.bookdataList.forEach((item) => {
            // status 0未答 1正确 2错误
           /* if (item.flag != 2) {
              if (!item.myanswer) {
                this.$set(item, "status", 0);
                this.num++;
              } else if (item.answer != item.myanswer) {
                this.$set(item, "status", 2);
                this.num++;
              } else {
                this.$set(item, "status", 1);
              }
            }

            // 多选题 答案 字符串转数组
            if (item.flag == 4) {
              if (!item.myanswer) {
                this.$set(item, "myanswer", []);
                this.$set(item, "status", 0);
              } else {
                this.$set(item, "myanswer1", item.myanswer.join(""));
                if (item.answer != item.userAnswer) {
                  this.$set(item, "status", 2);
                } else {
                  this.$set(item, "status", 1);
                }
                // item.myanswer.split("");
              }
            }*/
          });
          this.examList = res.data.bookdataList;
          // this.cardList = JSON.parse(res.data.userAnswer);
          // this.flag = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },

    // 返回上一页
    back() {
      this.$router.go(-1);
    },
    // 锚点定位
    goDingyue(id) {
      console.log(this.$refs[`examList${id}`][0].getBoundingClientRect());
      this.$el
          .querySelector(`.examList${id}`)
          .scrollIntoView({ block: "start", behavior: "smooth" });
    },
  },
};
</script>
<style lang="less" scoped>
.bgc {
  margin: 0 auto;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f5f5f5;
}
.w {
  margin: 0 auto;
  width: 1200px;
}
.bgc-kong {
  position: relative;
  width: 100%;
  height: 60px;
  border-radius: 20px 20px 0 0;
  font-size: 18px;
  /*text-align: center;*/
  /*line-height: 280px;*/
  color: rgba(142, 142, 142, 0.6);
  background-color: #ff6829;
  .examTop {
    /*width: 933px;*/
    display: flex;
    height: 60px;
    color: black;
    background-repeat: no-repeat;
    z-index: 2;
    .goBack {
      position: absolute;
      margin-top: 20px;
      left: 30px;
      cursor: pointer;
      font-size: 14px;
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .examName {

      margin-top: 20px;
      margin-left: 410px;
      font-size: 22px;
    }

    .examTime {
      margin-left: 160px;
      display: flex;
      align-items: center;
      font-size: 16px;
      div {
        width: 40px;
        height: 40px;
        margin: 0 10px;
        text-align: center;
        line-height: 40px;
        background-color: #8d876f;
        border-radius: 5px;
      }
    }
  }
}
.exam {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}
.examCont {
  width: 933px;
  background-color: #fff;
  box-sizing: border-box;
  min-height: 100vh;
  /*.examTop1 {*/
  /*height: 196px;*/
  /*background-color: #fff;*/
  /*z-index: 3;*/
  /*}*/
  /* .examTop {
     position: fixed;
     top: 5px;
     // left: calc((100vw - 1200px) / 2);
     width: 933px;
     height: 70px;
     color: #fff;
     !*background-image: url("../../assets/img/study/exam/bg_1_15.png");*!
     background-repeat: no-repeat;
     z-index: 2;
     .goBack {
       position: absolute;
       top: 40px;
       left: 30px;
       cursor: pointer;
       font-size: 14px;
       display: flex;
       align-items: center;
       img {
         width: 20px;
         height: 20px;
         margin-right: 10px;
       }
     }
     .examName {
       padding-top: 30px;
       font-size: 22px;
     }
     .step {
       display: flex;
       margin: 19px 0;
       font-size: 16px;
       color: #fff;

       div {
         margin-right: 20px;
       }
     }
     .examTime {
       display: flex;
       align-items: center;
       font-size: 16px;
       div {
         width: 40px;
         height: 40px;
         margin: 0 10px;
         text-align: center;
         line-height: 40px;
         background-color: #5cbeff;
         border-radius: 5px;
       }
     }
   }*/
}
/deep/
.text img{
  width :50px;
  height: 25px;
}
.examType {
  margin: 0 55px;
  margin-top: 100px;
  font-size: 14px;
  .examList {
    .topic {
       display: flex;
       align-items: center;
      line-height: 30px;

      .status {
        flex-shrink: 0;
        margin-right: 20px;
        width: 80px;
        height: 20px;
        line-height: 20px;
        color: #fff;
        text-align: center;
        border-radius: 15px;
        background-color: #029aff;
      }
      .status1 {
        background-color: #ff7402;
      }
      .status2 {
        background-color: #b502ff;
      }
      .status5 {
        background-color: #3f9951;
      }
      .status6 {
        background-color: #a9924f;
      }
      .status7 {
        background-color: #8dabba;
      }
      .status8 {
        background-color: #37b1a4;
      }
    }
    /deep/
    .option img{
      width :50px;
      height: 25px;
    }
    .option {
      margin-top: 10px;
      margin-left: 100px;
      .choose {
        display: block;
        margin-bottom: 10px;
      }
    }
    .option1 {
      margin-top: 10px !important;
      margin-left: 145px;
    }
    .topic1 {
      flex: 0;
      // margin-left: 20px;
      margin-bottom: 20px;
      // div {
      //   flex-shrink: 0;
      // }
    }
    .text {
      text-align: justify;
    }
    .filling {
      width: 100%;
      text-indent: 20px;
      margin-bottom: 30px;
      height: 40px;
      background-color: #fff;
      border: 1px solid #ccc;
    }
    .response {
      //   margin-left: 40px;
      //   width: 600px;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 15px;
      box-sizing: border-box;
      border-radius: 5px;
    }
    .contrast {
      span {
        &:first-child {
          color: #029aff;
          margin-right: 20px;
        }
      }
    }
  }
}
// 右侧答题卡
.answer {
  position: fixed;
  top: 20px;
  // right: 0;
  right: calc((100vw - 1200px) / 2);
  width: 250px;
  min-height: 80vh;
  background-color: #ffffff;
  padding-bottom: 30px;
  .answerTitile {
    text-align: center;
    line-height: 40px;
    height: 40px;
    background-color: #ff6829;
    color: #ffffff;
    font-size: 18px;
  }
  .answerTop {
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid #eaeaea;
    text-align: center;
    .whether {
      display: flex;
      justify-content: center;
      .whetherItem {
        display: flex;
        align-items: center;
        div:first-child {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          overflow: hidden;
          background-color: #029aff;
        }
        &:first-child {
          margin-right: 10px;
        }
        &:nth-child(2) {
          margin-right: 10px;
          div:first-child {
            border: 1px solid #029aff;
            box-sizing: border-box;
            background-color: transparent;
          }
        }
        &:last-child {
          div:first-child {
            background-color: #FC2727;
            box-sizing: border-box;
          }
        }
      }
    }
    .num {
      margin-top: 5px;
      span {
        color: #ff0000;
      }
    }
  }
}
.answerCard {
  margin-top: 20px;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 60vh;
  .type {
    margin: 12px 0;
    padding-left: 10px;
    height: 24px;
    line-height: 24px;
    color: #ff6829;
    font-size: 16px;
    border-left: 5px solid #029aff;
  }
  .answerList {
    margin: 0 30px;
    flex-wrap: wrap;
    width: 190px;
    // min-height: 60vh;
    // background-color: antiquewhite;
    div {
      cursor: pointer;
      width: 36px;
      height: 36px;
      color: #fff;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      background-color: #029aff;
      border-radius: 50%;
      margin-right: 41px;
      margin-bottom: 20px;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
    .noAnswer {
      color: #029aff;
      border: 1px solid #029aff;
      box-sizing: border-box;
      background-color: transparent;
    }
    .errorAnswer {
      background-color: #FC2727;
      box-sizing: border-box;
    }
  }
}
.submit {
  margin: 0 auto;
  margin-top: 30px;
  width: 140px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;
  background-color: #029aff;
  border-radius: 10px;
}
// 答案解析
.result {
  font-size: 18px;
  color: #343434;
  margin-bottom: 20px;
  span {
    color: #029aff;
    margin: 0 5px;
  }
  .big {
    font-size: 34px;
  }
}
.resultBtn_box {
  margin-top: 20px;
}
.resultBtn {
  width: 180px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  color: #fff;
  background: #029aff;
}
.resultBtn1 {
  color: #343434;
  background-color: #eaeaea;
}
.analysis {
  margin-top: 20px;
  margin-bottom: 40px;
  font-size: 18px;
  span {
    color: #029aff;
  }
}
/deep/ .el-radio {
  color: #343434;
}
::v-deep .el-radio__label {
  width: 100% !important;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 18px;

}
::v-deep .el-checkbox__label {
  display: inline-grid;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 20px;
}
/deep/ .el-radio__inner {
  cursor: default !important;
}
/deep/ .el-radio__inner::after {
  background-color: #029AFF !important;
}
/deep/ .el-radio__label {
  // cursor: pointer !important;
  color: #333 !important;
  cursor: default !important;
}
/deep/ .el-checkbox__label {
  color: #333 !important;
  cursor: default !important;
}
/deep/ .el-checkbox__inner {
  cursor: default !important;
}
/deep/ .is-checked .el-checkbox__inner {
  background-color: #029AFF !important;
  border-color: #029AFF !important;
}
/deep/ .is-checked .el-checkbox__inner::after {
  border-color: #fff !important;
}
/deep/ .el-textarea__inner:focus {
  border-color: #DCDFE6 !important;
}
/deep/ .el-textarea__inner:hover {
  border-color: #DCDFE6 !important;
}
.answerCard::-webkit-scrollbar {
  width: 4px;
  height: 5px;
}
.answerCard::-webkit-scrollbar-track {
  background: rgba(191, 191, 191, 0.4);
  border-radius: 4px;
}
.answerCard::-webkit-scrollbar-thumb {
  background: rgba(191, 191, 191, 1);
  border-radius: 4px;
}
.index {
  margin-right: 10px;
}
.warp {
  flex-shrink: 0;
}
.num {
  font-size: 12px;
}
</style>
